"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chatbot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const Chatbot_style_1 = require("./Chatbot.style");
const Chatbot = (props) => {
    const [showChatbot, setShowChatbot] = (0, react_1.useState)(true);
    const [isChatbotAvailable, setIsChatbotAvailable] = (0, react_1.useState)(false);
    const [scriptLoaded, setScriptLoaded] = (0, react_1.useState)(false);
    const chatbotRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const chatbot = document.getElementById('chatbot-container');
        if (chatbot != null) {
            chatbot.classList.remove('visible');
            chatbot.classList.add('hidden');
        }
    }, [showChatbot]);
    const sendAnalytics = (fromChatbot) => {
        let analyticsBody = {};
        if (fromChatbot) {
            analyticsBody = fromChatbot.detail;
        }
        else {
            analyticsBody = {
                action_name: 'uscita chatbot sinistri',
                action_detail: 'chiusura chatbot sinistri',
                action_effect: 'chatbot sinistri chiuso'
            };
        }
        const analyticsService = nodejs_library_1.Providers.AnalyticsService.getInstance();
        analyticsService.triggerLink(analyticsBody);
    };
    const manageExitPointEvent = (event) => {
        var _a;
        if (event === null || event === void 0 ? void 0 : event.detail) {
            const detail = event.detail;
            const intent = (_a = detail === null || detail === void 0 ? void 0 : detail.params) === null || _a === void 0 ? void 0 : _a.intent;
            //se l'intent non è di apertura camera o galleria, chiudi il chatbot web
            if (intent && intent !== 'openPhotoLibrary' && intent !== 'openCamera') {
                document.body.style.overflow = 'auto';
                const chatbot = document.getElementById('chatbot-container');
                if (chatbot != null) {
                    chatbot.classList.add('hidden');
                    chatbot.classList.remove('visible');
                }
                sendAnalytics();
            }
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('exit-point-event', manageExitPointEvent);
        window.addEventListener('analytics-event-sinistri', sendAnalytics);
        return () => {
            window.removeEventListener('exit-point-event', manageExitPointEvent);
            window.removeEventListener('analytics-event-sinistri', sendAnalytics);
        };
    }, [nodejs_library_1.Providers]);
    (0, react_1.useEffect)(() => {
        const dynamicScript = document.createElement('script');
        dynamicScript.type = 'text/javascript';
        dynamicScript.async = true;
        const url = window.location.href;
        if (url.includes(`dev.${nodejs_library_1.Helpers.BrandNameHelper.urlName()}`)) {
            dynamicScript.src =
                'https://chatbot-casa-widget-dev.servizi.gr-u.it/chatbot.js';
        }
        else if (url.includes('sit.unipol.it')) {
            dynamicScript.src =
                `https://inte.unipol.it/chatbot-denuncia-sinistri/widget/chatbot.js`;
        }
        else if (url.includes('qa.unipol.it') || url.includes('coll.unipolsai.it')) {
            dynamicScript.src =
                `https://qa.unipol.it/chatbot-denuncia-sinistri/widget/chatbot.js`;
        }
        else if (url.includes('apphub.unipolsai.it') || url.includes('apphub.unipol.it') || url.includes('www.unipol.it')) {
            dynamicScript.src =
                `https://www.unipol.it/chatbot-denuncia-sinistri/widget/chatbot.js`;
        }
        dynamicScript.id = 'chatbot-casa-servizi';
        // Optional: Handle script loading success
        dynamicScript.onload = () => __awaiter(void 0, void 0, void 0, function* () {
            setScriptLoaded(true);
            console.log('Chatbot script loaded successfully.');
            setIsChatbotAvailable(true);
            console.error('chatbot loaded');
        });
        // Optional: Handle script loading error
        dynamicScript.onerror = (error) => {
            console.error('Error loading the chatbot script:', error);
        };
        // Append the script to the document body
        document.body.appendChild(dynamicScript);
        // Cleanup function to remove the script when the component unmounts
        return () => {
            document.body.removeChild(dynamicScript);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(Chatbot_style_1.ContainerDiv, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'chatbot-wrapper hidden', id: 'chatbot-container' }, { children: (0, jsx_runtime_1.jsx)("div", { className: 'chatbot-container', dangerouslySetInnerHTML: {
                    __html: "<chatbot-component id='chatbot-widget'></chatbot-component>" // Ensure this is trusted content!
                } }) })) }));
};
exports.Chatbot = Chatbot;
